<template>
  <div>
    <!---------------------------------------- MAIN DIALOG ---------------------------------------->
    <v-dialog
      v-model="mainDialog"
      max-width="800"
      persistent
      :fullscreen="$vuetify.display.smAndDown"
      scrollable
    >
      <v-card>
        <!-- TITLE BAR -->
        <v-card-title class="redColor parts-list-title d-flex align-center ga-2">
          <div class="parts-list-title-text text-white flex-grow-1">
            <span class="text-subtitle-1 font-weight-medium d-block">
              {{ $t("vehicle_entry.parts_list.label") }}
            </span>
            <span
              v-if="vehicle?.brand?.title || vehicle?.model?.fullDescription"
              class="text-body-2 d-block"
            >
              <template v-if="vehicle?.brand?.title">{{
                vehicle.brand.title
              }}</template>
              <template v-if="vehicle?.model?.fullDescription">
                {{ " " + vehicle.model.fullDescription }}
              </template>
            </span>
          </div>
          <v-btn
            variant="outlined"
            icon
            color="white"
            class="parts-list-close-btn flex-shrink-0"
            size="small"
            @click="closeMainDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- CONTENT -->
        <v-card-text>
          <!-- Loading -->
          <v-row v-if="loading" align="center" justify="center">
            <v-progress-circular :size="50" color="red" indeterminate />
          </v-row>
          <!-- Previous lists -->
          <v-row
            v-if="
              partsList &&
              partsList.previousLists &&
              partsList.previousLists.length
            "
            class="d-flex flex-column justify-center"
          >
            <v-col v-for="item in partsList.previousLists" :key="item._id">
              <v-divider />
              <v-row class="justify-center align-center flex-wrap">
                <v-col cols="8" class="min-width-0">
                  {{ formatDate(item.date_created) }}
                </v-col>
                <v-col cols="4" class="d-flex justify-end">
                  <v-btn
                    variant="text"
                    icon
                    @click="openPreviousListDialog(item.list)"
                  >
                    <v-icon> mdi-format-list-bulleted </v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    variant="text"
                    @click="print(vehicle, item.list, partsList.notes)"
                  >
                    <v-icon> mdi-printer </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- View List -->
          <v-row v-if="!loading" class="justify-center mt-3">
            <v-btn color="red-darken-1" @click="openCurrentListDialog">
              {{ $t("vehicle_entry.parts_list.view_list") }}
              <v-icon end>mdi-format-list-bulleted</v-icon>
            </v-btn>
          </v-row>
        </v-card-text>
        <v-card-actions class="parts-list-actions pa-3">
          <v-spacer class="d-none d-md-flex" />
          <v-btn color="error" variant="outlined" @click="closeMainDialog">
            {{ $t("vehicle_entry.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------------------- LIST DIALOG ---------------------------------------->
    <v-dialog
      v-model="listDialog"
      max-width="800"
      persistent
      :fullscreen="$vuetify.display.smAndDown"
      scrollable
    >
      <v-card>
        <!-- TITLE BAR -->
        <v-card-title class="redColor parts-list-title d-flex align-center ga-2">
          <div class="parts-list-title-text text-white flex-grow-1">
            <span class="text-subtitle-1 font-weight-medium d-block">
              {{ $t("vehicle_entry.parts_list.label") }}
            </span>
            <span
              v-if="vehicle?.brand?.title || vehicle?.model?.fullDescription"
              class="text-body-2 d-block"
            >
              <template v-if="vehicle?.brand?.title">{{
                vehicle.brand.title
              }}</template>
              <template v-if="vehicle?.model?.fullDescription">
                {{ " " + vehicle.model.fullDescription }}
              </template>
            </span>
          </div>
          <v-btn
            variant="outlined"
            icon
            color="white"
            class="parts-list-close-btn flex-shrink-0"
            size="small"
            @click="closeListDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- CONTENT -->
        <v-card-text>
          <!-- List -->
          <v-row class="mt-3 parts-list-items">
            <v-col
              v-for="(item, index) in partsList.list"
              :key="index"
              cols="12"
              class="pa-0 ma-0"
            >
              <v-divider />
              <v-row class="flex-wrap align-center ma-0">
                <v-col cols="2" sm="1" class="py-0 pl-0 flex-shrink-0">
                  <v-checkbox
                    v-model="item.selected"
                    :disabled="disabled"
                    class="mt-4"
                    color="red-darken-1"
                    hide-details
                  />
                  <!-- :disabled="disabled || item.selectedPreviously" -->
                </v-col>

                <v-col cols="10" sm="11" md="5" class="py-0 min-width-0">
                  <div v-if="item.category" class="caption pt-5">
                    {{ item.category.it }}
                  </div>

                  <div class="subheading">
                    <!-- :style="item.selectedPreviously
                    ? { 'text-decoration-line': 'line-through' } : {} "
                    -->

                    {{ item.title && item.title.it ? item.title.it : "" }}
                  </div>
                </v-col>

                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    v-model="item.notes"
                    :disabled="disabled"
                    :label="$t('vehicle_entry.parts_list.notes')"
                    color="red-darken-1"
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!--Comment-->
          <v-textarea
            v-model="partsList.notes"
            :disabled="disabled"
            :label="$t('vehicle_entry.parts_list.notes')"
            color="red-darken-1"
          />
        </v-card-text>
        <v-card-actions class="parts-list-actions parts-list-list-actions pa-3">
          <div class="parts-list-actions-group">
            <v-btn
              color="success"
              :disabled="!partsList.list || partsList.list.length === 0"
              variant="outlined"
              @click="print(vehicle, partsList.list, partsList.notes)"
            >
              {{ $t("vehicle_entry.parts_list.print") }}
              <v-icon> mdi-printer</v-icon>
            </v-btn>
          </div>

          <div class="parts-list-actions-group parts-list-actions-footer">
            <v-btn color="error" variant="outlined" @click="closeListDialog">
              {{ $t("vehicle_entry.close") }}
            </v-btn>
            <v-btn
              color="primary"
              :disabled="disabled"
              variant="outlined"
              @click="save"
            >
              {{ $t("vehicle_entry.save") }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import QrCode from "qrcode";
import Printd from "printd";
// import { Printd } from 'printd';
import getRequest from "../../api/getRequest";

export default {
  filters: {
    fullDate(date) {
      moment.locale(localStorage.getItem("language"));
      return moment(date).format("LLL");
    },
  },
  data: () => ({
    mainDialog: false,
    listDialog: false,
    loading: false,
    disabled: false,
    vehicle: null,
    partsList: { previousLists: null, notes: null, list: null },
    _currentList: null,
    previousListMode: false,
  }),
  methods: {
    open(vehicle, partsList, disabled) {
      this.mainDialog = true;
      this.vehicle = vehicle;
      if (!partsList || !partsList.list || partsList.list.length === 0)
        this.getPartsList();
      else this.partsList = partsList;
      if (disabled) this.disabled = true;
    },
    closeMainDialog() {
      this.mainDialog = false;
      this.vehicle = null;
      this.partsList = { previousLists: null, notes: null, list: null };
      this.disabled = false;
      this.$emit("close");
    },
    openCurrentListDialog() {
      this.mainDialog = false; // Hide main dialog.
      this.listDialog = true;
      this.partsList.list.forEach((item, index) => {
        // Set the selected items as prev. selected.
        if (item.selected) {
          this.partsList.list[index].selectedPreviously = true;
        }
      });
      this._currentList = this.partsList.list.map((item) => item); // Copy current list.
    },
    openPreviousListDialog(list) {
      this.mainDialog = false;
      this.listDialog = true;
      this.disabled = true;
      this._currentList = this.partsList.list.map((item) => item); // Copy current list.
      this.partsList.list = list;
    },
    closeListDialog() {
      this.listDialog = false;
      this.mainDialog = true;
      this.partsList.list = this._currentList;
      this._currentList = null;
      this.disabled = false;
    },
    save() {
      if (!this.partsList.previousLists) this.partsList.previousLists = [];
      this.partsList.previousLists.push({ list: this._currentList });

      this.$emit("save", { ...this.partsList });
      this.closeListDialog();
      this.closeMainDialog();
    },
    formatDate(date) {
      if (!date) return "";
      moment.locale(localStorage.getItem("language") || "en");
      return moment(date).format("LLL");
    },
    print(vehicle, list, notes) {
      QrCode.toDataURL(vehicle._id, (error, qrCode) => {
        const qrImg = document.createElement("img");
        qrImg.setAttribute("src", qrCode);
        qrImg.style.width = "100px";
        qrImg.style.height = "100px";

        const qrId = document.createElement("div");
        qrId.textContent = vehicle._id.slice(
          vehicle._id.length - 6,
          vehicle._id.length,
        );
        qrId.setAttribute("class", "qrId");

        const img = document.createElement("div");
        img.setAttribute("class", "img");
        img.appendChild(qrImg);

        const row1 = document.createElement("div");
        row1.setAttribute("class", "row1");
        row1.appendChild(qrId);

        const row2 = document.createElement("div");
        row2.setAttribute("class", "row2");
        row2.innerHTML = `
        <div> ${vehicle.brand.title} </div>
        <div>
          <span> ${vehicle.model.fullDescription} </span>
          <span> ${vehicle.version.fullDescription} </span>
        </div>
      `;

        const wrapper = document.createElement("div");
        wrapper.setAttribute("class", "wrapper");
        wrapper.appendChild(img);
        wrapper.appendChild(row1);
        wrapper.appendChild(row2);

        const table = document.createElement("table");
        const thead = document.createElement("thead");
        const tbody = document.createElement("tbody");
        list.forEach((element) => {
          const row = document.createElement("tr");
          row.innerHTML = `
          <th> <input type="checkbox" ${element.selected ? "checked" : ""}> </th>
          <th> <span class="t ${element.selectedPreviously ? "lt" : ""}">${element.title.it || ""}</span> </th>
          <th> <span class="t">${element.notes || ""}</span> </th>
        `;
          tbody.appendChild(row);
        });
        thead.innerHTML = `
        <tr>
          <th> <span class="h"> Selezionato </span> </th>
          <th> <span class="h"> Titolo </span> </th>
          <th> <span class="h"> Note </span> </th>
        </tr>
      `;
        table.appendChild(thead);
        table.appendChild(tbody);

        const notesDiv = document.createElement("div");
        notesDiv.innerHTML = `
        <br>
        <div class="h"> Note: </div>
        <div class="t"> ${notes || ""} </div>
      `;

        const content = document.createElement("body");
        content.appendChild(wrapper);
        content.appendChild(table);
        content.appendChild(notesDiv);

        const css = `
        @media print {
          @page {
            size: A4;
            margin: 10px 0px 10px 0px;
          }

          body {
            -webkit-print-color-adjust: exact !important;
            font-family: "Roboto";
          }

          table {
            width: 100%;
          }

          thead {
            background-color: #C5C8D7;
          }

          thead th:nth-child(1) {
            width: 5%;
          }
          thead th:nth-child(2) {
            width: 45%;
          }
          thead th:nth-child(3) {
            width: 50%;
          }

          tbody tr:nth-child(odd) {
            background-color: #E0E1EB;
          }
          tbody tr:nth-child(even) {
            background-color: #C5C8D7;
          }

          th, td {
            text-align: left;
            padding: 0.2em;
          }

          .img {
            display: flex;
            justify-content: center;
          }
          .row1 {
            text-align: center;
            font-weight: bold;
            font-size: 20px;
            text-transform: uppercase;
            margin-bottom: 20px;
          }
          .row2 {
            margin-bottom: 10px;
            font-size: 24px;
          }

          .t {
            font-size: 14px;
            font-weight: bold;
          }

          .h {
            font-size: 16px;
            font-weight: bold;
          }

          .lt {
            text-decoration-line: line-through;
          }
        }`;
        const d = new Printd();
        d.print(content, [
          css,
          "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons",
        ]);
      });
    },
    getPartsList() {
      this.loading = true;
      getRequest("/car/part-list")
        .then((response) => {
          this.partsList.list = response;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.parts-list-title {
  padding: 12px 16px;
}

.parts-list-title-text {
  min-width: 0;
  line-height: 1.35;
  word-break: break-word;
}

.parts-list-items {
  overflow-x: hidden;
}

.parts-list-items .min-width-0 {
  min-width: 0;
  word-break: break-word;
}

@media (max-width: 959.98px) {
  .parts-list-title {
    position: relative;
    padding: 12px 52px 12px 16px;
  }

  .parts-list-close-btn {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
  }

  .parts-list-items :deep(.v-field) {
    min-width: 0;
  }

  .parts-list-actions {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }

  .parts-list-actions .v-btn {
    flex: 1 1 calc(50% - 8px);
    min-width: 0;
    max-width: 100%;
  }

  .parts-list-list-actions {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .parts-list-list-actions .parts-list-actions-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    width: 100%;
  }

  .parts-list-list-actions .parts-list-actions-footer {
    margin-top: 4px;
  }
}

@media (min-width: 960px) {
  .parts-list-list-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    gap: 8px;
  }

  .parts-list-list-actions .parts-list-actions-group:not(.parts-list-actions-footer) {
    display: contents;
  }

  .parts-list-list-actions .parts-list-actions-footer {
    display: flex;
    gap: 8px;
    margin-left: auto;
  }
}
</style>
